module.exports = __webpack_public_path__ + "static/media/systray_210.143da1e2.ico";